import { render } from "./UGCPanelDungeonTab.vue?vue&type=template&id=9676292a"
import script from "./UGCPanelDungeonTab.vue?vue&type=script&lang=js"
export * from "./UGCPanelDungeonTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__